import { render, staticRenderFns } from "./number-text-field.vue?vue&type=template&id=16be67e6&scoped=true"
import script from "./number-text-field.vue?vue&type=script&lang=js"
export * from "./number-text-field.vue?vue&type=script&lang=js"
import style0 from "./number-text-field.vue?vue&type=style&index=0&id=16be67e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be67e6",
  null
  
)

export default component.exports